<template>
  <div class="pageIntegralShop">  
    <XR-head :titleText="pointInfo.PointName + '商城'" :rightShow="true"></XR-head>
    <div class="signin" v-if="isLogin">
	  <div class="left">                
        <div class="info">
          <p class="desc"><span class="special">{{memberFinance.Integral}}{{pointInfo.PointName}}</span><span class="normal">可抵{{memberFinance.Integral}}元</span></p>
          <p class="tip" v-if="NowSignInfo.issign">您已连续签到{{NowSignInfo.signcount }}天</p>
          <p class="tip" v-if="!NowSignInfo.issign">您已连续签到{{NowSignInfo.signcount-1 }}天</p>
        </div>
      </div>
      <div class="right" @click="signin">
        <img src="/static/integral/signin-btn.png" class="signin-btn" />
        <div class="btn">            
          <template v-if="!NowSignInfo.issign">        
            <p class="btn-text">今日签到</p>
            <p class="award">+{{NowSignInfo.signpoint }}</p>
          </template>
          <template v-else>
            <p class="btn-text">明日签到</p>
            <p class="award">+{{TomorrowSignInfo.signpoint}}</p>
          </template>
        </div>
      </div>
    </div>

    <div class="bannerDiv">
      <router-link :to="bannerAd.AdLink"><img :src="bannerAd.AdImg" class="banner"></router-link>
    </div>

    <ul class="ph-nav clearfix">
      <li>
          <router-link to="/UserCenter/Integral" :title="pointInfo.PointName + '记录'">
              <img src="/static/icon/integral1.png">
              <em>{{pointInfo.PointName}}记录</em>
          </router-link>
      </li>
      <li>
          <p @click="toBeOnline" :title="'赚取' + pointInfo.PointName">                    
              <img src="/static/icon/integral3.png">
              <em>赚取{{pointInfo.PointName}}</em>
          </p>
      </li>
      <li>
          <p @click="toBeOnline" :title="pointInfo.PointName + '帮助'">              
              <img src="/static/icon/help.png">
              <em>{{pointInfo.PointName}}帮助</em>                    
          </p>
      </li>
      <li>
          <router-link to="/UserCenter/integralOrderList" title="我的兑换">         
              <img src="/static/icon/duihuan.png">
              <em>我的兑换</em>             
          </router-link>
      </li>
    </ul>   

    <ul class="ad-list">                                
      <li><router-link :to="AdLeft.AdLink"><img :src="AdLeft.AdImg"></router-link></li>                          
      <li><router-link :to="AdRight.AdLink"><img :src="AdRight.AdImg"></router-link></li>      
    </ul>
	<XR-load-more  :onLoadMore="onLoadMore" :enableLoadMore="enableLoadMore" ref="XRLoadMore">
    <div class="pro-list">
      <div :class="'item'+ (index%2==0?' rigthmargin':'') " v-for="(productItem,index) in integralProductList" :key="productItem.ProductId">
        <template v-if="productItem.SaleType == 1">          
          <div class="top">
            <router-link :to="'/retail/ProductDetail?skuId='+ productItem.SkuId"><img :style="{height: imgHeight+'px'}" :src="productItem.DefaultImage?productItem.DefaultImage: IMGServer_URL+'/images/index-item-default.png'" class="pro-img"></router-link>
            <div class="dk">
              <span>可抵</span>
              <span>{{productItem.IntegralPrice}}元</span>
            </div>
          </div>
          <div class="text">
            <div class="money">
              <p class="price">￥<span>{{productItem.SalePrice.toFixed(2)}}</span></p>
              <p class="del-price">￥{{productItem.Price.toFixed(2)}}</p>
            </div>
            <router-link :to="'/retail/ProductDetail?skuId='+ productItem.SkuId"><p class="name">{{productItem.ProductName}}</p></router-link>
            <p class="buycount">{{productItem.SaleCount}}人已购买</p>
          </div>
        </template>
        <template v-else>
          <div class="top">
            <router-link :to="'/integral/productDetail?skuId='+ productItem.SkuId"><img :style="{height: imgHeight+'px'}" :src="productItem.DefaultImage?productItem.DefaultImage: IMGServer_URL+'/images/index-item-default.png'" class="pro-img"></router-link>
            <div class="dk">
              <span>全额</span>
              <span>兑换</span>
            </div>
          </div>
          <div class="text">
            <div class="money">
              <p class="price">{{pointInfo.PointName}}<span>{{productItem.SalePrice.toFixed(2)}}</span></p>
              <p class="del-price">￥{{productItem.Price.toFixed(2)}}</p>
            </div>
            <router-link :to="'/integral/productDetail?skuId='+ productItem.SkuId"><p class="name">{{productItem.ProductName}}</p></router-link>
            <p class="buycount">{{productItem.SaleCount}}人已购买</p>
          </div>
        </template>
      </div>
	  <div v-if="isShowLastDefault" class="item" :style="{width:itemWidth+'px', marginBottom:0}">
		<img src="/static/index/index-item-default.png" style="display:block;width:100%;" />
	  </div>
    </div>
	</XR-load-more>
	
    <XR-toast ref="XRtoast"></XR-toast>
    <XR-signin ref="XRsigin" @onClose="readSignInfo"></XR-signin>
  </div>
</template>

<script>
import pointconfig from '../util/pointconfigCache'
export default {
  data(){
    return {
      pointInfo: pointconfig.getPointconfig(),
      integralProductList:[],
      bannerAd:{},
      AdLeft:{},
      AdRight:{},
      NowSignInfo:{},
      TomorrowSignInfo:{},
      memberFinance:{},
      isLogin:false,
	  itemWidth: document.documentElement.clientWidth * 0.49,
	  sWidth : document.documentElement.clientWidth,
	  imgHeight: 0,
	  isShowLastDefault:false,
	  page:1,
      pageSize:10,
      totalPage:0,
      enableLoadMore: true,
    }
  },
  mounted(){
    this.getPointInfo()
    this.getIntegralProductList(true)
    this.getIntegralAdList()

    if (this.$store.state.user.SessionId) {
      this.isLogin =true
      this.readSignInfo()
    }
	this.imgHeight = this.sWidth*0.49
  },
  methods:{    
    getPointInfo: function() {
      const ths = this;
      this.$post("/Shop/IntegralServer/GetPointSetParam")
      .then(function(res) {
        if (res.IsSuccess) {
		  ths.pointInfo = res.Data;
          pointconfig.addPointconfig(res.Data)
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getIntegralAdList(){
      const ths = this;
      this.$post("/Shop/AdServer/GetAdsByPage",{ClientType:2, pageId:'fc71c8460e214bb993cbab21017c5b78'})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false
          
          for(var i = 0; i< res.Data.length;i++){
            if(res.Data[i].AdName == '积分商城banner广告'){
              ths.bannerAd = res.Data[i];
            }
            else if(res.Data[i].AdName == '积分商城横幅广告（左）'){
              ths.AdLeft = res.Data[i];
            }
            else if(res.Data[i].AdName == '积分商城横幅广告（右）'){
              ths.AdRight = res.Data[i];
            }
          }

          ths.$refs.XRtoast.hide()
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getIntegralProductList(isNew){
      const ths = this;
      this.$post("/Shop/IntegralServer/GetIntegralProductList", {pageIndex: this.page, pageSize: ths.pageSize})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false
		  if(isNew){
            ths.integralProductList = res.Data.List
          }else{
            for(var i = 0; i < res.Data.List.length;i++){
              ths.integralProductList.push(res.Data.List[i])
            }
          }
		  ths.totalPage = res.Data.Rows % ths.pageSize ==0?res.Data.Rows / ths.pageSize:res.Data.Rows / ths.pageSize+1
          if(ths.page >= ths.totalPage){
            this.enableLoadMore = false
          }
          ths.isShowLastDefault = ths.integralProductList.length % 2==1?true:false
          ths.$refs.XRtoast.hide()
        }else{          
          ths.enableLoadMore = false
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getSignInfo(){
      const ths = this;
      this.$post("/Shop/UserServer/GetSigninGiveDayInfo")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false
          ths.$refs.XRtoast.hide()
          
          var signDate = new Date()
          var year = signDate.getFullYear()
          var month = (signDate.getMonth()+1)
          if(month <10){
            month = '0'+ month
          }
          var day = signDate.getDate()
          if(day <10){
            day = '0'+ day
          }
          var signDateString = year+"-"+month+"-"+day
          for(var i = 0; i < res.Data.itemlist.length;i++){
            var signItem = res.Data.itemlist[i]
            var tmpDate = signItem.date.split('T')[0]
            if(signDateString == tmpDate){
              ths.NowSignInfo = signItem
              break;
            }
          }
          ths.TomorrowSignInfo = res.Data.tomorrowitem
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },    
    getFinanceInfo: function() {
      var ths = this;
      this.$post(
        "/Shop/UserServer/GetMemberFinanceAccount"
      ).then(function(res) {
        ths.memberFinance = res.Data;
      });
    },
    toBeOnline:function(){
      this.$refs.XRtoast.load('拼命开发中...',true);
    },
    signin(){
      this.$refs.XRsigin.show()
    },
    readSignInfo(){
      this.getSignInfo()
      this.getFinanceInfo()
    },
	onLoadMore(done) {
      setTimeout(()=>{
          if(!this.enableLoadMore) {
              return
          }
          if(this.page >= this.totalPage){
            this.enableLoadMore = false
            return
          }
          this.page = this.page + 1
          this.getIntegralProductList(false);
          done();
      }, 200)
    },
  }
}
</script>

<style>
.pageIntegralShop .banner
{
    width:100%;    
    display:block;
}
.pageIntegralShop .ph-nav{
  padding:.8rem 0;
  background:white;
  overflow: hidden;
}
.pageIntegralShop .ph-nav li{
  float:left;
  width:25%;
  list-style: none;
}
.pageIntegralShop .ph-nav li img{ width:30%; padding:0; margin:0; display:block; margin:0 auto;}
.pageIntegralShop .ph-nav li em{
  font-size: .75rem;
  line-height: 1.0rem;
  color: #5A5655;
  display:block;
  text-align:center;
  font-style: normal;
}
.pageIntegralShop .ad-list { overflow:hidden; margin-bottom:0.2rem;}
.pageIntegralShop .ad-list li { float:left; width:50%; list-style: none;}
.pageIntegralShop .ad-list li img { width:100%; display:block;}

.pageIntegralShop .pro-list { background:#EEEDEE;}
.pro-list .item { width:49%; float:left; margin-bottom:5px; background:white;}
.pageIntegralShop .pro-list .item.rigthmargin { margin-right:2%;}
.pageIntegralShop .pro-list .item .top { position:relative;}
.pageIntegralShop .pro-list .item .top img { width:100%; height:150px; display:block;}
.pageIntegralShop .pro-list .item .top .dk { position:absolute; top:4px; right:4px; color:red;   text-align:center;}
.pageIntegralShop .pro-list .item .top .dk span { font-size:12px; display:block; height:14px; line-height:14px; font-weight:700;}
.pageIntegralShop .pro-list .text { padding:0 5px;}
.pageIntegralShop .pro-list .text .money { font-size:12px; overflow:hidden; margin:5px 0;} 
.pageIntegralShop .pro-list .text .money .price { float:left;color:Red;  padding-left:5px; line-height:1.0rem;}
.pageIntegralShop .pro-list .text .money .price span { font-size:16px; font-weight:700;}
.pageIntegralShop .pro-list .text .money .del-price { float:left; color:#A0A0A0; text-decoration:line-through; margin-left:10px; line-height:18px;}
.pageIntegralShop .pro-list .item .name {   width:100%; overflow:hidden; height:36px; line-height:18px; font-size:12px;}
.pageIntegralShop .pro-list .item .buycount { margin-bottom:5px; width:100%; overflow:hidden; height:16px; text-align:right; color:#EF8367; line-height:16px; font-size:12px;}

      
.pageIntegralShop .signin { height:70px; background:#F9CC9D; overflow:hidden;}
.pageIntegralShop .signin .left { float:left;margin-left:5px;}
.pageIntegralShop .signin .left .box-open { float:left; margin-top:6px; width:55px;}
.pageIntegralShop .signin .left .info { float:left; margin-top:21px; margin-left:4px;}
.pageIntegralShop .signin .left .info .desc { font-size:12px; overflow:hidden; }
.pageIntegralShop .signin .left .info .desc .special { font-size:16px;line-height:16px; color:#FF0000; float:left;}
.pageIntegralShop .signin .left .info .desc .normal { font-size:12px; line-height:14px; margin-left:5px; float:left;}
.pageIntegralShop .signin .left .info .tip { font-size:12px; line-height:12px; margin-top:3px;}
.pageIntegralShop .signin .right { float:right; margin-right:5px;}
.pageIntegralShop .signin .right .signin-btn { float:left; margin-top:14px; width:46px;}
.pageIntegralShop .signin .right .btn { float:left; margin-top:22px;margin-left:2px;}
.pageIntegralShop .signin .right .btn .btn-text { font-size:12px;line-height:12px;}
.pageIntegralShop .signin .right .btn .award { font-size:12px;line-height:12px; margin-top:6px;}  

</style>



// WEBPACK FOOTER //
// src/pages/integralshop.vue